import { Prisma } from '@prisma/client';

export const PROJECT_PUBLIC_SELECT = {
  id: true,
  impactType: true,
  title: true,
  slug: true,
  status: true,
  description: true,
  whySupport: true,
  shortSnippet: true,
  longSnippet: true,
  projectType: true,
  projectSubType: true,
  impactFact: true,
  fundedSince: true,
  lastVisit: true,
  videoLink: true,
  climateBenefits: true,
  natureBenefits: true,
  peopleBenefits: true,
  projectAssetsLink: true,
  primaryImage: { select: { id: true, imageKey: true, alt: true } },
  images: {
    orderBy: { sortOrder: 'asc' },
    select: { id: true, imageKey: true, alt: true },
  },
  locations: {
    select: {
      id: true,
      country: true,
      region: true,
      latitude: true,
      longitude: true,
      restorSiteId: true,
    },
  },
  sdgs: { orderBy: { sdgNumber: 'asc' }, select: { sdgNumber: true, explanation: true } },
  updates: {
    orderBy: { date: 'desc' },
    select: { id: true, type: true, title: true, content: true, date: true, imageKey: true, imageAlt: true },
  },
  impactPartners: {
    select: {
      partner: { select: { id: true, title: true, slug: true, imageKey: true, description: true, link: true } },
    },
  },
  verificationPartners: {
    select: {
      evidenceLink: true,
      partner: { select: { id: true, title: true, slug: true, imageKey: true, description: true, link: true } },
    },
  },
} satisfies Prisma.ProjectSelect;

export const PROJECT_PUBLIC_SUMMARY_SELECT = {
  id: true,
  impactType: true,
  title: true,
  slug: true,
  status: true,
  projectType: true,
  projectSubType: true,
  impactFact: true,
  primaryImage: { select: { id: true, imageKey: true, alt: true } },
  images: {
    orderBy: { sortOrder: 'asc' },
    select: { id: true, imageKey: true, alt: true },
  },
  locations: {
    select: {
      id: true,
      country: true,
      region: true,
      latitude: true,
      longitude: true,
      restorSiteId: true,
    },
  },
  sdgs: { orderBy: { sdgNumber: 'asc' }, select: { sdgNumber: true, explanation: true } },
} satisfies Prisma.ProjectSelect;

export const PROJECT_PUBLIC_DETAIL_SELECT = {
  ...PROJECT_PUBLIC_SELECT,
} satisfies Prisma.ProjectSelect;

export const PROJECT_UPDATE_SELECT = {
  id: true,
  projectId: true,
  type: true,
  title: true,
  content: true,
  date: true,
  imageKey: true,
  imageAlt: true,
} satisfies Prisma.ProjectUpdateSelect;
